import { LAYERS_CONFIG } from "../../../config/layer.config";

export enum OriginType {
  Coordinates = 'Coordinates',
  Country = 'Country',
  Shapefile = 'Shapefile',
  GeoJSON = 'GeoJSON',
}

export const ORIGIN_TYPE_OPTIONS = [OriginType.Coordinates, OriginType.Country, OriginType.Shapefile, OriginType.GeoJSON];

export const { REFERENCE_DATA, WORLD_COUNTRIES } = LAYERS_CONFIG;

export interface IAnalysisCounts {
  total: number;
}

export const loadCountryparams = {
  where: '1=1',
  outFields: ['Country Name'],
  returnGeometry: false,
  returnDistinctValues: true,
};


export type Position = [number, number, ...number[]];

export interface LineString {
  type: 'LineString';
  coordinates: Position[];
}
export interface Polygon {
  type: 'Polygon';
  coordinates: Position[][];
}
export type Geometry =
  | LineString
  | Polygon
// Properties: Generic to allow any key-value pairs
export type Properties = { [key: string]: any } | null;

export interface Feature<T extends Geometry = Geometry, P = Properties> {
  type: 'Feature';
  geometry: T | null;
  properties: P;
  id?: string | number;
}

export interface GeoJSONgeneric<T extends Geometry = Geometry, P = Properties> {
  type: 'FeatureCollection';
  features: Feature<T, P>[];
}

// Union of all GeoJSON types
// type GeoJSON =
// | FeatureCollection;


